/**
 * Input Atom
 *
 * Campo de input reutilizável
 */
import React, { forwardRef } from 'react'

const Input = forwardRef(({
	label,
	error,
	icon: Icon,
	className = '',
	...props
}, ref) => {
	return (
		<div className={className}>
			{label && (
				<label className="block text-sm font-medium text-text mb-1">
					{label}
				</label>
			)}
			<div className="relative">
				{Icon && (
					<div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
						<Icon className="h-5 w-5 text-text-body" />
					</div>
				)}
				<input
					ref={ref}
					className={`
            block w-full rounded-lg border border-base-200
            bg-base-300 px-4 py-2.5 text-text
            placeholder:text-text-body
            focus:border-primary focus:ring-2 focus:ring-primary/20
            disabled:bg-base-300 disabled:cursor-not-allowed
            ${Icon ? 'pl-10' : ''}
            ${error ? 'border-danger focus:border-danger focus:ring-danger/20' : ''}
          `}
					{...props}
				/>
			</div>
			{error && (
				<p className="mt-1 text-sm text-danger">{error}</p>
			)}
		</div>
	)
})

Input.displayName = 'Input'

export default Input
